import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";

// routing
import Routes from "./routes";

// defaultTheme
import themes from "./themes";

// project imports
import { SocketProvider } from "./utils/context/SocketContext";
import { ProgressLoader } from "./utils/context/ProgressLoader";

import { useEffect } from "react";
import OneSignal from 'react-onesignal';
import useAuthWatcher from "@/hooks/useAuthWatcher";

// ==============================|| APP ||============================== //
if (process.env.NODE_ENV === 'development') {
  console.log('Production env checking : ', { env: process.env.NODE_ENV })
}

let initedOneSignal = false
const App = () => {

  useAuthWatcher();

  useEffect(() => {
    if (!initedOneSignal) {

      const isNotProduction = process.env.NODE_ENV !== 'production' || process.env.REACT_APP_BASENAME !== 'live';

      if (isNotProduction) {
        console.log('[OneSignal] skipped: not production');
        return;
      }

      console.log(isNotProduction,process.env.NODE_ENV !== 'production' , process.env.REACT_APP_BASENAME !== 'live')

      OneSignal.init({ appId: `${process.env.REACT_APP_ONE_SIGNAL_APP_ID}`, allowLocalhostAsSecureOrigin: true }).then(async () => {
        if (OneSignal.Slidedown) {
          OneSignal.Slidedown.promptPush();
        }
        if (OneSignal.Notifications) {
          OneSignal.Notifications.requestPermission();
        }
      })
      initedOneSignal = true;
    }
  }, [])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes()}>
        <ProgressLoader>
          <SocketProvider>
            <CssBaseline />
            <Routes />
          </SocketProvider>
        </ProgressLoader>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
